import React from 'react'
import SuburbMap from './SuburbMap'
import AddressMap from './AddressMap'

const Map = (props) => {
  if (props.polygonCoords.length > 0) {
    return(
      <div className='map-placeholder'>
        <SuburbMap
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${gon.services.google_map_api_key}`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `400px` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          polygonCoords={props.polygonCoords}/>
      </div>
    )
  }

  if (Object.keys(props.coords).length > 0) {
    return(
      <AddressMap
        coords={ props.coords }
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${gon.services.google_map_api_key}`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `400px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        zoom={ props.zoom }
      />
    )
  }

  return(null)
}

export default Map
